import { reduxForm, formValueSelector } from 'redux-form';
import { checkPassword, clearCheckPassword,fetchBaseUsers, fetchUserDetail, fetchGroups, fetchGroupDetail, fetchPermissions, editUserDetail, createUserDetail, resetPassword, resetUserDetail } from '../../actions/settings_actions';
import { connect } from 'react-redux';

import UserManagementDetail from '../../components/Settings/userManagementDetail';

const validate = values => {
  const errors = {}
  if ( values.password && values.passwordConfirm && values.password != values.passwordConfirm) {
      errors.password = 'password does not match!'
  }
  return errors;
}

let userManagementDetail = reduxForm({
    form: 'userManagementDetail',
    validate
})(UserManagementDetail);

function mapStateToProps(state) {
    return {
        currentUser: state.settings.currentUser,
        userDetail: state.settings.userDetail,
        isLoading: state.settings.userDetailIsLoading,
        error: state.settings.userDetailError,
        initialValues: state.settings.userDetail,
        groups: state.settings.groups,
        groupsError: state.settings.groupsError,
        groupsIsLoading: state.settings.groupsIsLoading,
        groupDetail: state.settings.groupDetail,
        groupDetailIsLoading: state.settings.groupDetailIsLoading,
        groupDetailError: state.settings.groupDetailError,
        permissions: state.settings.permissions,
        permissionsIsLoading: state.settings.permissionsIsLoading,
        permissionsError: state.settings.permissionsError,
        createUserDetailError: state.settings.createUserDetailError,
        userPermissions: state.auth.userPermissions,
        checkPasswordSuccess: state.settings.checkPasswordSuccess,
        checkPasswordFailure: state.settings.checkPasswordFailure,
    };
}

export default connect(mapStateToProps, { checkPassword,clearCheckPassword,fetchBaseUsers, fetchUserDetail, fetchGroups, fetchGroupDetail, fetchPermissions, editUserDetail, createUserDetail, resetPassword, resetUserDetail })(userManagementDetail);



// WEBPACK FOOTER //
// ./master/jsx/containers/Settings/userManagementDetail.jsx